<template>
  <footer class="footer">
    <div class="footer_content">
      <div class="footer_info">
        <h1>
          <img :src="logo" alt="" v-if="logo" />
          <p>{{ name }}</p>
        </h1>
        <div style="width: 40px;height: 2px;background: #4B7DFD;border-radius: 1px;margin-top: 20px; margin-bottom: 28px;"></div>
        <ul class="fs-12">
          <li v-for="route in menus" :key="route.name">
            <router-link style="color: #646568;" :to="{name: route.name, query: { ocode: ocode } }">{{ route.title }}</router-link>
          </li>
        </ul>
        <!-- <p class="fs-12" style="margin:30px 0 10px;color: #646568;">Copyright©2013-2021 {{
          isOther ? '云浮市永盛教育科技有限公司' : '福建铸远教育科技有限公司'
        }}版权所有</p>
        <p class="fs-12">
          <a style="color: #646568;" href="https://beian.miit.gov.cn" target="_blank">{{
          isOther ? '粤ICP备2023112846号-2' : '闽ICP备14031391号-1'
        }}</a>
        </p> -->
      </div>
      <div>
        <h3 class="fs-14" style="color: #fff">APP&小程序</h3>
        <div class="footer_relevant">
          <div>
            <h1 style="width:80px; height:80px;">
              <img style="width: 100%; height: 100%;" src="@/assets/appqrcode.png" alt="">
            </h1>
            <p>乐私塾APP</p>
          </div>
          <div>
            <h1 style="width:80px; height:80px;">
              <img style="width: 100%; height: 100%;" :src="qrcodeUrl" alt="微信小程序二维码" v-if="qrcodeUrl">
            </h1>
            <p v-if="qrcodeUrl">小程序</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { featchAppQrCode } from '@/api/system'
import Vue from 'vue'
import { QR_CODE } from '@/store/mutation-types'
export default {
  name: 'BaseLauoutFooter',
  props: {
    name: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menus: [
        {
          title: '关于我们',
          name: 'about'
        },
        {
          title: '隐私条款',
          name: 'privacy'
        },
        {
          title: '用户协议',
          name: 'user'
        },
        {
          title: '法律声明',
          name: 'law'
        },
        {
          title: '联系我们',
          name: 'contact'
        }
      ],
      qrcodeUrl: '',
      ocode: Vue.ls.get('code'),
      isOther: false,
    }
  },
  created() {
    // const qrcodeUrl = localStorage.getItem('qrcodeUrl')
    const qrcodeUrl = Vue.ls.get(QR_CODE)
    if (qrcodeUrl === '' || qrcodeUrl === null || qrcodeUrl === undefined) {
      this.qrCode()
    } else {
      this.qrcodeUrl = qrcodeUrl
    }
    const code = Vue.ls.get('code')
    if (code === 'yfys') {
      this.isOther = true
    }
  },
  methods: {
    async qrCode() {
      try {
        const res = await featchAppQrCode()
        this.qrcodeUrl = res.qrcodeUrl
        // localStorage.setItem('qrcodeUrl', this.qrcodeUrl)
        Vue.ls.set(QR_CODE, this.qrcodeUrl)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
li {
  list-style: none;
}
h3 {
  color: #fff;
  font-weight: 500;
}
.fs-16 {
  font-size: 16px;
}
.fs-14 {
  font-size: 14px;
  color: #7E8EA1;
}
.fs-12 {
  font-size: 14px;
  color: #7E8EA1;
}
.footer {
  max-height: 280px;
  background-color: #1D1E22;
  .footer_content {
    width: 1200px;
    height: 280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .footer_info {
      width: 483px;
      h1 {
        img {
          height: 36px;
          margin-bottom: 18px;
          border-radius: 5px;
          object-fit: contain;
        }
        p {
          font-weight: bold;
          font-size: 16px;
          color: #fff;
        }
      }
      ul {
        display: flex;
        align-items: center;
        li {
          margin-right: 33px;
        }
      }
      // h3 {
      //   margin-top: 16px;
      // }
      .ant-divider-horizontal {
        background: #324150;
      }
    }
    .footer_relevant {
      display: flex;
      margin-top: 10px;
      p {
        margin-top: 12px;
      }
      & div:first-child {
        margin-right: 20px;
      }
    }
  }
}
</style>
